import autosize from "autosize/dist/autosize";
window.addEventListener('load', function() {
    autosize(document.querySelectorAll('textarea'))
})